import React from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { levelsDashboardStore } from "../LevelsDashboardStore";
import { GWP_M2_AREA_UNIT } from "utils";

/** Building-wide total for the currently selected hotspot indicator. */
export default observer(function HotspotTotal() {
  const { t } = useTranslation();
  const total = levelsDashboardStore.hotspotInfo?.total;

  if (total == null) return null;

  return (
    <div className="flex items-baseline gap-2 mb-4 text-gray-700">
      <span className="text-xs uppercase font-bold text-gray-400">
        {t("levels.hotspotTotal")}
      </span>
      <span className="font-bold text-lg">{total.toFixed(2)}</span>
      <span className="text-xs text-gray-400">{GWP_M2_AREA_UNIT}</span>
    </div>
  );
});
